import * as React from 'react';

export interface IPagesContext {
  activePage: string;
}

export const PagesContext = React.createContext<IPagesContext>({
  activePage: null,
});
